import { useTranslation } from "react-i18next";
import { Button, Tooltip, Typography } from "@material-ui/core";
import ConfirmDelete from "components/ConfirmDelete";
import { ItemContainer } from "./Styles";
import AccountStatus from "./AccountStatus";
import { AccountType } from "./helpers";
import { MailboxSingleAccountProvider } from "../types";
import { StorageProviderWithAuth } from "@dashboard-v3/api";

type Params = {
  id: string;
  provider: StorageProviderWithAuth | MailboxSingleAccountProvider;
  accountType: AccountType;
  user: string;
  synced: boolean;
  missingRefreshToken?: boolean;
  enableAccount: (
    user: string,
    provider: StorageProviderWithAuth | MailboxSingleAccountProvider
  ) => void;
  deleteStorageAccount: (id: string) => void;
  deleteMailboxAccount: (id: string) => void;
};

export default function AccountItem({
  id,
  provider,
  accountType,
  user,
  synced,
  missingRefreshToken,
  enableAccount,
  deleteStorageAccount,
  deleteMailboxAccount,
}: Params) {
  const { t } = useTranslation("storage");

  const onDelete = (id: string) => {
    if (accountType === AccountType.Storage) {
      deleteStorageAccount(id);
    }
    if (accountType === AccountType.Mailbox) {
      deleteMailboxAccount(id);
    }
  };

  const handleAuthorize = () => enableAccount(user, provider);

  const needsAuth = !synced || missingRefreshToken;

  return (
    <ItemContainer data-testid="storage__account-list-item">
      <Typography variant="caption" style={{ fontSize: "14px" }}>
        {user}
      </Typography>
      <Typography variant="caption" style={{ fontSize: "14px" }}>
        {t(`accountItem.provider.${provider}`)}
      </Typography>

      <Typography variant="caption" style={{ fontSize: "14px" }}>
        {t(`accountList.item.accountType.${accountType}`)}
      </Typography>
      <AccountStatus
        synced={synced}
        missingRefreshToken={missingRefreshToken}
      />
      <div style={{ textAlign: "right" }}>
        {needsAuth && (
          <Tooltip title={t("authorizeTooltip")}>
            <Button
              variant="outlined"
              size="small"
              color="primary"
              onClick={handleAuthorize}
              data-testid="storage__authorize-account-btn"
              style={{ marginRight: 8 }}
            >
              {t("authorize")}
            </Button>
          </Tooltip>
        )}
        <ConfirmDelete
          onAccept={() => onDelete(id)}
          variant="outlined"
          size="small"
          message={t(`confirmDeletion.${accountType}`, {
            type: t(`accountItem.provider.${provider}`),
            user,
          })}
        />
      </div>
    </ItemContainer>
  );
}
